import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { FxButtonBase } from "../../fxms/inputs/FxButton";
import { FxTextFieldBase } from "../../fxms/inputs/FxTextField";
import { FxForm, FxFormButtons } from "../../fxms/inputs/FxForm";
import { FxWindow } from "../../fxms/windows/FxWindows";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxActionBase } from "../../fxms/actions/FxAction";

/*마이페이지> 1:1문의 등록 화면 */
export const UI_MyInfo_CU = (props) => {
  const [inputDatas, setInputDatas] = React.useState(FxmsData.user);
  const [editableYn, setEditableYn] = React.useState(true);   
  const selectedData =FxmsData.user;
   
  useEffect(() => {    
    console.log("UI_MyInfo_CU", props);      
  }, []);

  function onChangeValue(id, value) {
    let newData = { ...inputDatas };

    if (value) {
      newData[id] = value;
    } else {
      delete newData[id];
    }
    setInputDatas(newData);
  }
  
   const onRegister = async() => { 
    /*문의분류 제목 필수 체크 추가해야함 */
        if(inputDatas===selectedData) { 
          FxWindow.alert("변경된 사항이 없습니다.", true) 
          return ;
        }
            
       // 추가
        let caller = new FxActionBase("fxUrUser/modifyMember", "PUT");
        caller.execute(inputDatas, function (bret) {
          console.log("UI_MyInfo_CU regist result ", bret);
          onUpdate();
          FxmsData.refreshMemberInfo();
        });        
  }

const onUpdate = () => { 
    setEditableYn(!editableYn);
  } 

  return (
    <>
    <FxForm style={{ width: '1180px', borderColor: 'green' }}
      cols={['100px', '400px', '100px', '400px']}
      rows={[
        {
          inputs: ["산업단지명"
            ,<FxTextFieldBase name="complexName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true}/>             
            , "회사명"
            ,  <FxTextFieldBase name="companyName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true}/>
          ]
          , colspan: [1, 1, 1, 1]
        }
        , {
          inputs: ["공장명", <FxTextFieldBase name="plantName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={true} /> ]           
          , colspan: [1, 3]
        }

        , {
          inputs: ["소재지", <FxTextFieldBase name="addr" onChangeValue={onChangeValue}   selectedData={selectedData} disabled={true} />]
          , colspan: [1, 3]
        }

        , {
          inputs: ["규모", <FxTextFieldBase name="scale" onChangeValue={onChangeValue}   selectedData={selectedData} disabled={true} />
            , "홈페이지", <FxTextFieldBase name="url" onChangeValue={onChangeValue}  selectedData={selectedData} disabled={editableYn} />]
          , colspan: [1, 1, 1, 1]
        }
        ,{
          inputs: ["업종", <FxTextFieldBase name="domain" onChangeValue={onChangeValue}   selectedData={selectedData} disabled={true} />
            , "주생산품", <FxTextFieldBase name="mainProduct" onChangeValue={onChangeValue}  selectedData={selectedData} disabled={editableYn} />]
          , colspan: [1, 1, 1, 1]
        }
        , {
          inputs: ["대표번호", <FxTextFieldBase name="telNum"  onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn}/>
            , "팩스번호", <FxTextFieldBase name="faxNum"  onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn}/>]
          , colspan: [1, 1, 1, 1]
        }
        ,  {
          inputs: ["담당자명", <FxTextFieldBase name="cntcrName" onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn}/>
            , "담당자 연락처", <FxTextFieldBase name="cntcrEmail"  onChangeValue={onChangeValue} selectedData={selectedData} disabled={editableYn}/>]
          , colspan: [1, 1, 1, 1]
        }  
      ]
      }
    >
    </FxForm>
    {editableYn? <><FxFormButtons
        center={[<FxButtonBase key={uuidv4()} name="click" onClick={onUpdate} text="수정" />]} /></> :
        <><FxFormButtons
        center={[<><FxButtonBase key={uuidv4()} name="click" onClick={onUpdate} text="취소" /><FxButtonBase key={uuidv4()} name="click" onClick={onRegister} text="저장" /></>]} /></>}
    <ul className="VupFileUpNotice">
    <li>회사명 및 공장명, 소재지 등 변경이 필요한 경우 관리자에게 1:1문의해주시기 바랍니다 </li>
    </ul>
  </>
  )
}
